// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"02913039","97":"c961cb30","167":"2edbfb36"}[chunkId] + ".chunk.js";
};